
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { FileText, Eye, Clock, Star } from 'lucide-react';
import type { Tables } from '@/integrations/supabase/types';

type Node = Tables<'nodes'>;

interface ContentStatsProps {
  nodes: Node[];
}

const ContentStats: React.FC<ContentStatsProps> = ({ nodes }) => {
  const stats = [
    {
      title: 'Total Content',
      value: nodes?.length || 0,
      icon: FileText,
      color: 'text-black',
    },
    {
      title: 'Published',
      value: nodes?.filter(n => n.status === 'published').length || 0,
      icon: Eye,
      color: 'text-green-600',
    },
    {
      title: 'In Review',
      value: nodes?.filter(n => n.status === 'in_review').length || 0,
      icon: Clock,
      color: 'text-black',
    },
    {
      title: 'Featured',
      value: nodes?.filter(n => n.featured).length || 0,
      icon: Star,
      color: 'text-black',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-black">{stat.title}</p>
                <p className={`text-2xl font-bold ${stat.color}`}>{stat.value}</p>
              </div>
              <stat.icon className={`h-8 w-8 ${stat.color}`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ContentStats;
